import React from 'react';
import { useSystemStatus } from '../contexts/SystemStatusContext';

const MaintenancePage = () => {
    const { maintenanceConfig } = useSystemStatus();

    if (!maintenanceConfig) return null;

    const endAt = maintenanceConfig.endAt?.toDate();
    const formattedEndAt = endAt ? new Intl.DateTimeFormat('ja-JP', {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Tokyo'
    }).format(endAt) : '';

    // 自動メンテナンス (autoEnabled) の場合は終了時刻を表示しない
    const isAutoMaintenance = maintenanceConfig.autoEnabled === true;

    return (
        <div className="w-full flex items-center justify-center p-4">
            <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-8 text-center border border-gray-100">
                <div className="mb-6">
                    <svg className="mx-auto h-16 w-16 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                </div>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">現在システムメンテナンス中です。</h2>
                
                {formattedEndAt && !isAutoMaintenance && (
                    <div className="mb-6">
                        <p className="text-sm font-semibold text-gray-600">終了予定日時：</p>
                        <p className="text-lg text-gray-800">{formattedEndAt}</p>
                    </div>
                )}

                {maintenanceConfig.message && (
                    <div className="bg-gray-50 rounded p-4 text-left whitespace-pre-wrap text-gray-700 border border-gray-200">
                        {maintenanceConfig.message}
                    </div>
                )}
                
                <p className="mt-8 text-sm text-gray-500">
                    ご不便をおかけいたしますが、しばらくお待ちください。
                </p>
            </div>
        </div>
    );
};

export default MaintenancePage;
